// RMI-2026-591 (react-refresh/only-export-components): split out of
// ThemeContext.jsx, which now exports only the ThemeProvider component.
import { createContext, useContext } from 'react';

export const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);
